import { render, staticRenderFns } from "./messaging-service-add-edit-dialog.vue?vue&type=template&id=bdeb1efc"
import script from "./messaging-service-add-edit-dialog.vue?vue&type=script&lang=js"
export * from "./messaging-service-add-edit-dialog.vue?vue&type=script&lang=js"
import style0 from "./messaging-service-add-edit-dialog.vue?vue&type=style&index=0&id=bdeb1efc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports